import { useNavigate } from "react-router-dom";
import "./Privacy.css";
import { Helmet } from "react-helmet-async";

export const PrivacyPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Yuva Quest</title>
        <link rel="canonical" href="https://yuvaquest.com/privacy" />
        <meta
          name="description"
          content="Read how Yuva Quest collects, uses, and protects your personal data in our privacy policy."
        />
      </Helmet>
      <div className="webUi my_custom_section ">
        <p className="webUi">Privacy Policy</p>
      </div>

      <div className="formdiv container ">
        <h5 className="webUi">1.Privacy Policy</h5>
        <p className="webUi">
          We, River Comics LLC <strong>(“River Comics/ We“)</strong>, value the
          trust you place in us. In this Privacy Policy we describe the
          information that we collect about you{" "}
          <strong>(“You/ User/ Customer/ Member“)</strong> when you visit our
          website{" "}
          <span className="btn btn-link p-0" onClick={() => navigate("/")}>
            www.yuvaquest.com
          </span>{" "}
          <strong>(“Website“)</strong> or use our mobile application{" "}
          <strong>(“Application“)</strong> and use the services available
          therefrom <strong>(“Services“)</strong> (collectively referred to as
          the <strong>“Program“</strong>). That’s why we insist upon the highest
          standards for secure transactions and customer information privacy.
          Please read the following statement to learn about our information
          gathering and dissemination practices.
          <br />
          Our privacy policy is subject to change at any time without notice. To
          make sure you are aware of any changes, please review this policy
          periodically.
          <br />
          By visiting this Website and/or downloading our Mobile App onto your
          mobile device you agree to be bound by the terms and conditions of
          this Privacy Policy. If you do not agree please do not use or access
          our Website and/or download our App onto your mobile device.
          <br />
          By mere use of the Website and/or Application, you expressly consent
          to our use and disclosure of your personal information in accordance
          with this Privacy Policy. This Privacy Policy is incorporated into and
          subject to the Terms of Use available at{" "}
          <span className="btn btn-link p-0" onClick={() => navigate("/terms")}>
            Terms of Service
          </span>
        </p>
        <h5 className="webUi">
          2.Use of Demographic / Profile Data / Your Information
        </h5>
        <p className="webUi">
          We use personal information to provide the services you request. To
          the extent we use your personal information to market to you, we will
          provide you the ability to opt-out of such uses. We use your personal
          information to resolve disputes; troubleshoot problems; help promote a
          safe service; collect money; measure consumer interest in our products
          and services, inform you about online and offline offers, products,
          services, and updates; customize your experience; detect and protect
          us against error, fraud and other criminal activity; enforce our terms
          and conditions; and as otherwise described to you at the time of
          collection.
          <br />
          In our efforts to continually improve our product and service
          offerings, we collect and analyze demographic and profile data about
          our user’s activity on our Website.
          <br />
          We identify and use your IP address to help diagnose problems with our
          server, and to administer our Website/Application. Your IP address is
          also used to help identify you and to gather broad demographic
          information.
          <br />
          We will occasionally ask you to complete optional online surveys.
          These surveys may ask you for contact information and demographic
          information (like zip code, age, or income) We use this data to tailor
          your experience at our Website/Application, providing you with content
          that we think you might be interested in and to display content
          according to your preferences.
        </p>
        <h5 className="webUi">3. What we Collect</h5>
        <p className="webUi">
          We may collect personal information from you, such as your name, email
          address, postal address, phone number, credit card number, gender,
          birthday, personal interests, etc., when you visit our Websites,
          install or use the Application, place an order online or by phone,
          save your information with us online, contact us with a question or
          concern, or participate in a contest, promotion, or survey. We
          maintain a record of your product interests and the
          subscriptions/purchases you make through the Program. We also collect
          information from or about the devices you use to access our Program
          such as your computer’s Internet Protocol (“IP address”), your browser
          type, your operating system, media access control (“MAC address”),
          received signal strength indicator (“RSSI”) and other technical
          information. If you use different devices to access the Program, such
          as your home computer, laptop and/or mobile device, we may be able to
          associate each of your devices with your account. Our Application may
          also collect information about your location if you have allowed this.
          We may combine all of this information with information about you that
          we acquire from your activities on our Program and/or information we
          receive from our joint marketing partners, unrelated third parties,
          and from our Merchants.
          <br />
          If you choose to post messages on our message boards, chat rooms or
          other message areas or leave feedback, we will collect that
          information you provide to us. We retain this information as necessary
          to resolve disputes, provide customer support and troubleshoot
          problems as permitted by law.
          <br />
          If you send us personal correspondence, such as emails or letters, or
          if other users or third parties send us correspondence about your
          activities or postings on the Website/Application, we may collect such
          information into a file specific to you.
        </p>
        <h5 className="webUi">4. How we use the Information</h5>
        <p className="webUi">
          We may use your personal information in the following ways:
          <br />
          • To process and fulfill your subscription/order, including to send
          you emails to confirm your subscription/order status and shipment
          <br />• To communicate with you and to send you information by email,
          postal mail, telephone, text message, or other means about our
          products, services, contests, and promotions, unless you have directed
          us not to contact you with promotional communications
          <br />• To administer and fulfill our contests and other promotions
          <br />• To help us better understand your shopping needs and
          preferences and provide consistent, personalized services and
          experiences across our brands.
          <br />• To help us address problems with and improve our Program
          <br />• To enhance your shopping, viewing experience
          <br />• To analyze trends and statistics
          <br />• To protect the security or integrity of our Program
          <br />• To contact you if necessary
        </p>
        <h5 className="webUi">5. How we share the Information</h5>
        <p className="webUi">
          We may share your personal information in the following ways:
          <br />• When you provide personal information with us we may share
          that information with our affiliates.
          <br />• We may share your information with our service providers who
          manage our customer information and perform services on our behalf,
          such as fulfilling promotions, fulfilling orders, sending
          communications to our customers, conducting surveys, etc. We do not
          authorize any of these service providers to make any other use or
          disclosure of your information.
          <br />• We may share your information when we team up with another
          company to offer or provide products, services, contests, or
          promotions to our customers.
          <br />• We may share information about you if necessary, in our good
          faith judgment, to comply with laws or regulations or in response to
          an order, or government request, or to protect our rights.
          <br />• We may share personal information with our other corporate
          entities and affiliates to help detect and prevent identity theft,
          fraud and other potentially illegal acts; correlate related or
          multiple accounts to prevent abuse of our services; and to facilitate
          joint or co-branded services that you request where such services are
          provided by more than one corporate entity. Those entities and
          affiliates may not market to you as a result of such sharing unless
          you explicitly opt-in.
          <br />• We may disclose personal information if required to do so by
          law or in the good faith belief that such disclosure is reasonably
          necessary to respond to subpoenas court orders, or other legal
          process. We may disclose personal information to law enforcement
          offices, third party rights owners, or others in the good faith belief
          that such disclosure is reasonably necessary to: enforce our Terms or
          Privacy Policy; respond to claims that an advertisement, posting or
          other content violates the rights of a third party; or protect the
          rights, property or personal safety of our users or the general
          public.
          <br />• We and our affiliates will share / sell some or all of your
          personal information with another business entity should we (or our
          assets) plan to merge with, or be acquired by that business entity, or
          re-organization, amalgamation, restructuring of business. Should such
          a transaction occur that other business entity (or the new combined
          entity) will be required to follow this privacy policy with respect to
          your personal information.
          <br />
          In addition, if you choose to participate in any third-party scrip,
          loyalty, or similar program in which any of our Merchants are a
          participating vendor, and you authorize us or our credit card
          processor to provide information about your purchases to the company
          administering the program, we will share your personal information
          with that program. Scrip programs allow you to instruct us to divert a
          percentage of the amount you spend on our Program to participating
          schools and other non-profit organizations. Loyalty programs allow you
          to earn “points” on purchases through our Program, which you may then
          use toward certain rewards offered by the loyalty programs in which
          you participate. The information you authorize us to disclose to the
          third-party scrip or loyalty program may include your credit card
          number and the date and amount of your purchase, and may also include
          your name and other information you have asked us to provide. Please
          note that once we disclose this information, the scrip or loyalty
          company may use and share it with others in accordance with its own
          privacy policy. You should review these policies carefully, as we have
          no control over them.
          <br />
          In the unlikely event of a sale or merger of River Comics or any of
          our businesses, our customers’ personal information and other
          information we have collected as described in this policy may be among
          the transferred business assets.
        </p>
        <h5 className="webUi">6. Modification of the Information</h5>
        <p className="webUi">
          You can review and change certain personal information related to your
          use of our Program. To access your information, simply sign in to your
          Account using your Username and password, and you will be able to edit
          your personal information in your Account profile.
        </p>
        <h5 className="webUi">7. Cookies</h5>
        <p className="webUi">
          Our Program uses “cookies,” and pixel tags and other tracking
          technologies, to help enable you to browse/shop through our Program
          and may be used in a variety of ways to enhance or personalize your
          online browsing, viewing and shopping experience. These technologies
          may also be used to determine the ads you see on our Program and also
          on other sites.
          <br />
          You can set your browser not to accept cookies or to notify you when
          you are sent a cookie, giving you the opportunity to decide whether or
          not to accept it. If you do not accept cookies, however, you will not
          be able to access your account information or make purchases on our
          websites.
          <br />
          Cookies, pixel tags and other tracking technologies help us better
          understand your shopping needs and preferences tell us which parts of
          our Program you have visited and facilitate and measure the
          effectiveness of our advertisements, and provide consistent and
          personalized services and experiences.
          <br />
          These technologies may be used to collect “click-stream data”, which
          includes information about your visit, including the pages you view,
          the features you use, the links you click, and other actions you take
          in connection with the sites and our online ads. Pixel tags in our
          emails may be used to track your interactions with those messages,
          such as when you receive, open, or click a link in an email message
          from us. We may combine the information we collect through these
          technologies with other information we have collected from and about
          you and use it as described in this policy.
          <br />
          We do our best to provide you with a safe and convenient shopping
          experience. We have in place certain physical, electronic,
          contractual, and managerial safeguards to protect the security and
          privacy of your personal information. When you enter your personal
          information on our Program, we use encryption technology to protect
          your information as it is transmitted to us.
          <br />
          Our goal is to make the Program as good, useful and rewarding for you
          as possible.
        </p>
        <h5 className="webUi">8.Links to Other Sites</h5>
        <p className="webUi">
          Our Website/ Application may link to other websites that may collect
          personally identifiable information about you. We are not responsible
          for the privacy practices or the content of those linked websites.
        </p>
        <h5 className="webUi">9. Security Precautions</h5>
        <p className="webUi">
          We have stringent security measures in place to protect the loss,
          misuse, and alteration of the information under our control. Whenever
          you change or access your account information, we offer the use of a
          secure server. Once your information is in our possession we adhere to
          strict security guidelines, protecting it against unauthorized access.
        </p>
        <h5 className="webUi">10. Choice/Opt-Out</h5>
        <p className="webUi">
          We provide all users with the opportunity to opt-out of receiving
          non-essential (promotional, marketing-related) communications from us
          on behalf of our partners, and from us in general, after setting up an
          account.
          <br />
          If you want to remove your contact information from all
          www.yuvaquest.com lists and newsletters, please visit{" "}
          <span className="btn btn-link p-0" onClick={() => navigate("/")}>
            https://www.yuvaquest.com
          </span>
        </p>
        <h5 className="webUi">11. Advertisements on Yuvaquest.com</h5>
        <p className="webUi">
          We use third-party advertising companies to serve ads when you visit
          our Website and/or download our Applications. These companies may use
          information (not including your name, address, email address, or
          telephone number) about your visits to this and other websites in
          order to provide advertisements about goods and services of interest
          to you.
        </p>
        <h5 className="webUi">12. Your Consent</h5>
        <p className="webUi">
          By using the Website/ Application and/ or by providing your
          information, you consent to the collection and use of the information
          you disclose on the Website/Application in accordance with this
          Privacy Policy, including but not limited to your consent for sharing
          your information as per this privacy policy.
          <br />
          If we decide to change our privacy policy, we will post those changes
          on this page so that you are always aware of what information we
          collect, how we use it, and under what circumstances we disclose it.
        </p>
        <h5 className="webUi">13. Questions?</h5>
        <p className="webUi">
          Questions regarding this statement should be directed to the following
          address:{" "}
          <span
            className="btn btn-link p-0"
            onClick={() => {
              window.location.href = "mailto:support@yuvaquest.com";
            }}
          >
            support@yuvaquest.com
          </span>
        </p>
      </div>
    </>
  );
};
